import { createContext } from 'react';
import { IServiceTransfersDto } from '@shared/api';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { IPaymentRequestsDesc } from './PaymentRequestsTableProvider';

export interface IPaymentRequestTableContext {
    date: null | string;
    paymentRequests: IServiceTransfersDto[];
    paymentRequestsLoading: boolean;
    paginationOptions: PaginationOptions | null;
    paymentRequestsType: string[];
    sortFieldName: string;
    desc: IPaymentRequestsDesc | null;
    handlePaymentRequestsSort: (fieldName: string) => void;
    paymentRequestsMethod: string[];
    onPaymentRequestViewClick: (paymentRequest: IServiceTransfersDto) => void;
    setDate: (date: string | null) => void;
    setSearch: (date: string) => void;
    setPaymentRequestsType: (type: string[]) => void;
    setPaymentRequestsMethod: (method: string[]) => void;
}

export const PaymentRequestsTableContext = createContext<IPaymentRequestTableContext>({
    date: null,
    paymentRequests: [],
    paymentRequestsLoading: false,
    paginationOptions: null,
    paymentRequestsType: [],
    desc: null,
    sortFieldName: '',
    handlePaymentRequestsSort: emptyFunc,
    paymentRequestsMethod: [],
    onPaymentRequestViewClick: emptyFunc,
    setDate: emptyFunc,
    setSearch: emptyFunc,
    setPaymentRequestsType: emptyFunc,
    setPaymentRequestsMethod: emptyFunc,
});
